import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

type SectionTitleProps = {
  slim?: boolean;
};

export const SectionTitle = styled.h4<SectionTitleProps>(
  props => css`
    font-size: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0;
    margin-bottom: ${layout.measurements.spacing025};
    padding: 0 ${layout.measurements.spacing100};

    ${props.slim &&
      css`
        margin-bottom: ${layout.measurements.spacing050};
      `}
  `
);

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: ${layout.measurements.fontSizeNormal};
  margin-top: ${layout.measurements.spacing050};
`;

export const SectionActions = styled.div`
  display: flex;
  margin-left: auto;
`;

export const SectionAction = styled.span`
  :last-child {
    margin-right: ${layout.measurements.spacing050};
  }
`;
